import { Link } from "react-router-dom";

// Original logo file, displayed unmodified (only the surrounding white margin is outside the visible box).
export const Logo = ({ className = "h-11 w-[150px]", to = "/" }) => (
  <Link to={to} data-testid="header-logo-link" className={`relative block overflow-hidden ${className}`} aria-label="Juppo">
    <img src="/juppo-logo.png" alt="Juppo" className="absolute left-1/2 top-1/2 h-[200%] max-w-none -translate-x-1/2 -translate-y-1/2" />
  </Link>
);
